import * as ReactDOM from 'react-dom/client';

import { initializeAPM } from '@zeta-commons';
import App from './app/app';
import './styles.css';

// Initialize APM as early as possible
initializeAPM();

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(<App />);
